import ConnectAccounts from '../../../onboarding/components/ConnectAccounts';

export default function ConnectAccountsScreen() {
    return <ConnectAccounts />;
}
